export default "__VITE_ASSET__cea31508__"